import AdminCustomerItem from 'pages/customer/item/admin';
import TeleconsultationsCalendar from 'pages/calendar/teleconsultations';
import NurseTeleconsultationPage from 'pages/teleconsultation/nurse';
import Customers from 'pages/customer/index';
import DoctorItem from 'pages/doctor/item';
import Doctors from 'pages/doctor/index';
import DoctorsAdd from 'pages/doctor/add';
import DoctorsEdit from 'pages/doctor/edit';
import ExamsCalendar from 'pages/calendar/exams';
import FirstTeleconsultationsPage from 'pages/teleconsultation/first';
import Polygraphies from 'pages/polygraphy/index';
import PolygraphiesAddPage from 'pages/polygraphy/add';
import PolygraphiesEdit from 'pages/polygraphy/edit';
import PolygraphiesItem from 'pages/polygraphy/item';
import Polysomnographies from 'pages/polysomnography/list';
import PolysomnographiesEdit from 'pages/polysomnography/edit';
import PolysomnographiesItem from 'pages/polysomnography/item';
import PolysomnographiesAddPage from 'pages/polysomnography/add';
import PsadRepAdd from 'pages/psad_rep/add';
import PsadRepItem from 'pages/psad_rep/item';
import PsadReps from 'pages/psad_rep';
import PsadRepsEdit from 'pages/psad_rep/edit';
import Renewals from 'pages/renewals/list';
import ResponseEdit from 'pages/response/edit';
import ResponseItem from 'pages/response/item';
import Responses from 'pages/response';
import SecondTeleconsultations from 'pages/teleconsultation/second';
import TaskAdd from 'pages/task/add';
import Tasks from 'pages/task';
import TechnicianAdd from 'pages/technician/add';
import TechnicianEdit from 'pages/technician/edit';
import TechnicianItem from 'pages/technician/item';
import Technicians from 'pages/technician';
import TeleconsultationItem from 'pages/teleconsultation/item/admin';
import TreatmentAdd from 'pages/treatment/add';
import TreatmentEdit from 'pages/treatment/edit';
import TreatmentItem from 'pages/treatment/item/index';
import TreatmentList from 'pages/treatment/list/index';
import ReferralItem from 'pages/referral/item';
import AdminDocumentItem from 'pages/document/item/admin';
import DocumentEdit from 'pages/document/edit/index';
import DocumentUpdate from 'pages/document/update';
import InvoiceAdd from 'pages/invoice/add/index';

import NoAccess from 'pages/no_access';

export const roles = {
  admin: {
    teleconsultation: {
      nurseTeleconsultations: NurseTeleconsultationPage,
      firstTeleconsultations: FirstTeleconsultationsPage,
      secondTeleconsultations: SecondTeleconsultations,
      renewalTeleconsultation: Renewals,
      item: TeleconsultationItem,
    },
    polygraphy: {
      index: Polygraphies,
      add: PolygraphiesAddPage,
      item: PolygraphiesItem,
      edit: PolygraphiesEdit,
    },
    polysomnography: {
      item: PolysomnographiesItem,
      add: PolysomnographiesAddPage,
      index: Polysomnographies,
      edit: PolysomnographiesEdit,
    },
    calendar: {
      exams: ExamsCalendar,
      teleconsultations: TeleconsultationsCalendar,
    },
    treatment: {
      add: TreatmentAdd,
      edit: TreatmentEdit,
      list: TreatmentList,
      item: TreatmentItem,
    },
    customer: {
      item: AdminCustomerItem,
      list: Customers,
      patients: Customers,
    },
    doctor: {
      item: DoctorItem,
      add: DoctorsAdd,
      list: Doctors,
      edit: DoctorsEdit,
    },
    technician: {
      list: Technicians,
      add: TechnicianAdd,
      item: TechnicianItem,
      edit: TechnicianEdit,
    },
    psadRep: {
      list: PsadReps,
      add: PsadRepAdd,
      item: PsadRepItem,
      edit: PsadRepsEdit,
    },
    referral: {
      item: ReferralItem,
    },
    response: {
      list: Responses,
      item: ResponseItem,
      edit: ResponseEdit,
    },
    task: {
      add: TaskAdd,
      list: Tasks,
    },
    document: {
      generateDAP: NoAccess,
      item: AdminDocumentItem,
      update: DocumentUpdate,
      edit: DocumentEdit,
    },
    invoice: {
      list: NoAccess,
      add: InvoiceAdd,
    },
  },
};
